<template>
  <a
    :href="url"
    target="_blank"
  >
    <Icon
      class="description"
      :width="24"
      :height="24"
      :name="icon"
    />
  </a>
</template>
  
<script setup lang='ts'>
import Icon from '@/common/components/atoms/Icon';

defineProps<{
  icon: string,
  url: string,
}>();
</script>
  
